import _ from 'lodash';

import pressHaptic from '@/helpers/press-haptic';

import errorHandler from './error-handler';
import notify from './notify';

export default function notifyError(
  error: Error | any,
  defaultErrorMessage?: string,
  haptic: boolean = true,
) {
  if (haptic) {
    pressHaptic('notificationError');
  }

  const message = errorHandler(
    error,
    _.get(error, 'response.message', defaultErrorMessage),
  );

  return notify({
    message,
    type: 'error',
    duration: 6000,
  });
}
